module.exports = __webpack_public_path__ + "img/best.2e2f68b5.svg";